// @flow
import { domainProperties } from '../config';
import { DomainProps } from '../types/domainProperties'
import { Map } from 'immutable';

function getPropertiesForCurrentDomain() {
  const currentHostname = window.location.hostname;
  const domainFromConfig = getDomainFromConfig(currentHostname);
  return domainProperties.get(domainFromConfig || 'www.drononline.gisonline.pl');
}

function getDomainFromConfig(currentHostname) {
  const availableDomains = Array.from(domainProperties.keys());
  return availableDomains.find(domain => domain === currentHostname);
}

export function getBaseUrl() {
  return getPropertiesForCurrentDomain().BASE_URL;
}

let initialState: DomainProps = Map(getPropertiesForCurrentDomain());

function DomainPropertiesReducer(state: DomainProps = initialState, action) {
  return state;
}

export default DomainPropertiesReducer;


// WEBPACK FOOTER //
// ./src/reducers/domainProperties.jsx